/**
 * INBAR+co — Collection Page Scripts
 * File: assets/inbar-collection.js
 *
 * Handles:
 * - Protocol kit accordion toggle
 * - Add to cart (Shopify AJAX Cart API)
 * - Prestige cart drawer refresh
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────
     KIT ACCORDION
  ───────────────────────────────────────────── */
  function icToggleKit(id) {
    var row = document.getElementById(id);
    if (!row) return;
    var isOpen = row.classList.contains('open');
    document.querySelectorAll('.ic-kit-row').forEach(function (r) {
      r.classList.remove('open');
    });
    if (!isOpen) {
      row.classList.add('open');
    }
  }

  // Expose globally so inline onclick attributes work
  window.icToggleKit = icToggleKit;


  /* ─────────────────────────────────────────────
     ADD TO CART
  ───────────────────────────────────────────── */
  function icAddToCart(btn) {
    var variantId = btn.dataset.variantId;

    if (!variantId || variantId === 'undefined' || variantId === '') {
      console.warn(
        'INBAR+co: No Variant ID found on this button. ' +
        'Open the Theme Customizer, find this product block, and paste the Shopify Variant ID into the "Shopify Variant ID" field.'
      );
      return;
    }

    var orig = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;
    btn.style.opacity = '0.6';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error(data.description || 'Cart error');
          });
        }
        return res.json();
      })
      .then(function () {
        btn.textContent = 'Added ✓';

        // Prestige theme cart drawer — try the most common event names
        // Prestige v6+ uses 'cart:open' and refreshes via a Stimulus controller
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));

        // Fallback: reload the cart section if Prestige exposes it via Shopify.sections
        if (window.Shopify && window.Shopify.sections) {
          window.Shopify.sections.load('cart-drawer');
        }

        setTimeout(function () {
          btn.textContent = orig;
          btn.style.opacity = '';
          btn.disabled = false;
        }, 2000);
      })
      .catch(function (err) {
        console.error('INBAR+co cart error:', err.message);
        btn.textContent = 'Try again';
        btn.style.opacity = '';
        btn.disabled = false;
        setTimeout(function () {
          btn.textContent = orig;
        }, 2000);
      });
  }

  // Expose globally
  window.icAddToCart = icAddToCart;


  /* ─────────────────────────────────────────────
     DELEGATED CLICK HANDLER
     Catches any .ic-pcard__atc, .ic-pcard-hero__atc,
     .ic-kit-atc, .ic-kit-row__cta clicks that use
     onclick="icAddToCart(this)" and also handles
     kit row toggles cleanly without relying on
     inline onclick on the row itself.
  ───────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    var ic = document.querySelector('.ic');
    if (!ic) return;

    // Kit row click — toggle open/close
    ic.addEventListener('click', function (e) {
      var kitRow = e.target.closest('.ic-kit-row');
      if (!kitRow) return;

      // Don't toggle if user clicked a button or link inside the row
      if (e.target.closest('button') || e.target.closest('a.ic-kit-view')) return;

      // Don't close by clicking inside the expanded body area
      if (e.target.closest('.ic-kit-row__body')) return;

      icToggleKit(kitRow.id);
    });

    // Science item collapsible — delegated click on .ic-science__item
    ic.addEventListener('click', function (e) {
      var sciItem = e.target.closest('.ic-science__item');
      if (!sciItem) return;
      sciItem.classList.toggle('open');
    });

    // Spa note collapsible — delegated click on .ic-spa__row-summary
    ic.addEventListener('click', function (e) {
      var spaSummary = e.target.closest('.ic-spa__row-summary');
      if (!spaSummary) return;
      var row = spaSummary.parentElement;
      if (row && row.classList.contains('ic-spa__row')) {
        row.classList.toggle('open');
      }
    });

    // FAQ collapsible — delegated click on .ic-faq__row-summary
    ic.addEventListener('click', function (e) {
      var faqSummary = e.target.closest('.ic-faq__row-summary');
      if (!faqSummary) return;
      var row = faqSummary.parentElement;
      if (row && row.classList.contains('ic-faq__row')) {
        row.classList.toggle('open');
      }
    });

    /* ─────────────────────────────────────────────
       OPEN FIRST ITEM BY DEFAULT (all 4 accordion types)
       Matches PDP behavior — first item of each accordion
       group renders pre-opened on page load.
    ───────────────────────────────────────────── */
    var firstKit = ic.querySelector('.ic-kit-row');
    if (firstKit && !firstKit.classList.contains('open')) {
      firstKit.classList.add('open');
    }

    var firstSci = ic.querySelector('.ic-science__item');
    if (firstSci && !firstSci.classList.contains('open')) {
      firstSci.classList.add('open');
    }

    var firstSpa = ic.querySelector('.ic-spa__row');
    if (firstSpa && !firstSpa.classList.contains('open')) {
      firstSpa.classList.add('open');
    }

    var firstFaq = ic.querySelector('.ic-faq__row');
    if (firstFaq && !firstFaq.classList.contains('open')) {
      firstFaq.classList.add('open');
    }
  });

})();
